module.exports = __webpack_public_path__ + "img/var_02_xrobot1_backlight.0b9fd425.svg";